import React, { useState, useEffect } from 'react';
import UsersTable from './usersTable';
import constant from '../../constant';
import { useParams } from 'react-router-dom';

const UsersContent = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { hospitalId } = useParams();

  useEffect(() => {
    const fetchUsers = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        setError('No authentication token found');
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(`${constant.REACT_APP_API_URL}/hospital/${hospitalId}/user/`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        const result = await response.json();
        if (response.ok) {
          // Map API response to match expected structure
          setUsers(result.map(user => ({
            user_id: user.user_id,
            name: user.name,
            email: user.email,
            password: user.password,
            role: user.role,
            hospital_id: user.hospital_id,
            created_on: user.created_on,
            created_by: user.created_by || 'system',
            is_active: user.is_active,
          })));
        } else {
          setError(result.message || 'Failed to fetch users');
        }
      } catch (error) {
        setError('Error fetching users');
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const handleDelete = async (id) => {
    const token = localStorage.getItem('token');
    if (!token) {
      setError('No authentication token found');
      return;
    }

    try {
      const response = await fetch(`${constant.REACT_APP_API_URL}/hospital/${hospitalId}/user/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      const result = await response.json();
      if (response.ok) {
        // Remove the deleted user from state
        setUsers(users.filter((user) => user.user_id !== id));
      } else {
        setError(result.message || 'Failed to delete user');
      }
    } catch (error) {
      setError('Error deleting user');
    }
  };

  const handleEdit = (updatedUser) => {
    setUsers(users.map((user) =>
      user.user_id === updatedUser.user_id ? updatedUser : user
    ));
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-full">
        <div className="spinner"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-10 text-red-500">
        {error}
        <button
          onClick={() => setError(null)}
          className="ml-4 px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700"
        >
          Clear Error
        </button>
      </div>
    );
  }

  return (
    <div className="px-6 pt-16 md:pt-0">
      <div className="">
        <UsersTable
          users={users}
          onDelete={handleDelete}
          onEdit={handleEdit}
        />
      </div>
    </div>
  );
};

export default UsersContent;